/* eslint-disable no-undef */
/* eslint-disable no-console */
import React, { Component } from "react";
import { captureMessage, captureException } from "@sentry/browser";
import PropTypes from "prop-types";
class ErrorHandler extends Component {

    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        };
    }

    componentDidCatch(error, info) {
        captureException(error);
        console.log(info);
        captureMessage("CLIENT ERROR", "error");
        this.setState({ hasError: true });
    }

    render() {
        return this.state.hasError ? <div /> :  this.props.children;
    }
}

ErrorHandler.propTypes = {
    children: PropTypes.any
};

export default ErrorHandler;
